import React from 'react';
import Button, {ButtonSize, ButtonType} from "../../gd-components/buttons/gd-button/gd-button-ui5-new";


// import Button from '../../gd-components/buttons/gd-button/gd-button';

type Props = {
    message         : any, //PropTypes.object.isRequired,
    comment         : string,

    yesBtnLabel     : string,
    noBtnLabel      : string,

    onYesCallback   : callback,
    onNoCallback?   : callback // not sure if we use it
};

type State = {
    yesClicked      : boolean
}

export default class ModalConfirm extends React.Component<Props, State> {



    static defaultProps = {
        yesBtnLabel: "Yes",
        noBtnLabel: "Cancel"
    };

    constructor(props:Props) {
        super(props);

        this.state = {
            yesClicked: false   // use to show "busy" state
        };
    }

    onYesClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();

        this.setState({yesClicked:true});
        this.props.onYesCallback();
    }

    onNoClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        gd.modal.hide();
        if (this.props.onNoCallback) this.props.onNoCallback();
    }

    renderYesNo() {
        // const yesBtnType = this.state.yesClicked ? 'busy' : 'blue';
        const yesBtnType = this.state.yesClicked ? ButtonType.BUSY : ButtonType.PRIMARY;
        return (
            <div className="actions flex-row-center-center m-t-50">
                <Button label={this.props.yesBtnLabel} type={yesBtnType} onClick={this.onYesClick} size={ButtonSize.STANDARD} />
                <Button label={this.props.noBtnLabel} onClick={this.onNoClick} size={ButtonSize.STANDARD} />
            </div>
        );
    }

    render() {
        return (
            <div className="">
                {this.props.message}
                {!!this.props.comment &&
                    <div className="comment">{this.props.comment}</div>
                }
                {this.renderYesNo()}
            </div>
        );
    }
};